export default __webpack_public_path__ + "static/media/mobi-info1.0e3e3eb3.webp";